import type { ReactNode } from 'react'
import { Button } from './Button'

type MaintenanceScreenProps = {
  title?: string
  description?: string
  details?: ReactNode
  onRetry?: () => void
  retryLabel?: string
}

const DEFAULT_TITLE = 'Сервис временно недоступен'
const DEFAULT_DESCRIPTION =
  'Мы уже работаем над восстановлением. Попробуйте обновить страницу через несколько секунд.'

export function MaintenanceScreen({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  details,
  onRetry,
  retryLabel = 'Обновить',
}: MaintenanceScreenProps) {
  return (
    <section className="min-h-screen flex items-center justify-center bg-slate-50 px-4 py-8">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-6 text-center shadow-sm">
        <h1 className="text-xl font-semibold text-slate-900">{title}</h1>
        <p className="mt-3 text-sm text-slate-600">{description}</p>
        {details ? <div className="mt-3 text-xs text-slate-500">{details}</div> : null}
        <div className="mt-6 flex justify-center">
          <Button onClick={onRetry ?? (() => window.location.reload())}>{retryLabel}</Button>
        </div>
      </div>
    </section>
  )
}
